import {
  useTranslation
} from "../../../../chunk-6N4NEKWU.mjs";
import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ThinkingIndicator/ThinkingIndicator.tsx
import { useEffect, useId, useRef, useState } from "react";
import { isStreamLive } from "../../../../domain/index.mjs";
import { useExitPresence } from "../../../../hooks/useExitPresence.mjs";
import { Collapse, Spinner, Text } from "../../../primitive/index.mjs";
import { ChatMarkdown } from "../../ChatMarkdown/index.mjs";
import { ShimmerText } from "../ShimmerText/index.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function ThinkingIndicator({ content, isLastItem, sessionStatus, resolveLink }) {
  const { t } = useTranslation();
  const contentId = useId();
  const [expanded, setExpanded] = useState(false);
  const [userInteracted, setUserInteracted] = useState(false);
  const previousContentRef = useRef(content);
  const previousIsLastRef = useRef(isLastItem);
  const isStreaming = isLastItem && isStreamLive(sessionStatus);
  const animateState = useRef({ charStartTimes: /* @__PURE__ */ new Map() });
  const spinnerRef = useRef(null);
  const { rendered: showSpinner, closing: spinnerClosing } = useExitPresence(isStreaming || void 0, spinnerRef);
  if (!isStreaming) {
    animateState.current.charStartTimes.clear();
  }
  useEffect(() => {
    const contentChanged = content !== previousContentRef.current;
    const becameNotLast = previousIsLastRef.current && !isLastItem;
    previousContentRef.current = content;
    previousIsLastRef.current = isLastItem;
    if (contentChanged && isStreaming && !userInteracted) {
      setExpanded(true);
    }
    if (becameNotLast) {
      setUserInteracted(false);
      setExpanded(false);
    }
  }, [content, isLastItem, isStreaming, userInteracted]);
  const handleToggle = () => {
    setExpanded(!expanded);
    if (isStreaming) {
      setUserInteracted(true);
    }
  };
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- the toggle below is the keyboard path; role='button' here would make the reasoning markdown the button's own name and strip the semantics a reader needs to read it
    /* @__PURE__ */ jsxs(
      "div",
      {
        onClick: handleToggle,
        className: "buyscout-timeline-thinking",
        children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              className: "buyscout-timeline-thinking-toggle",
              "aria-expanded": expanded,
              "aria-controls": content ? contentId : void 0,
              onClick: (event) => {
                event.stopPropagation();
                handleToggle();
              },
              children: t("thinking.toggle")
            }
          ),
          content ? /* @__PURE__ */ jsx("div", { className: "buyscout-timeline-thinking-content", children: /* @__PURE__ */ jsx(Collapse, { id: contentId, in: expanded, timeout: 200, collapsedSize: "var(--bs-thinking-collapsed, 21px)", children: /* @__PURE__ */ jsx("div", { className: "buyscout-thinking-process", children: /* @__PURE__ */ jsx(ChatMarkdown, { content, isStreaming, animateState: animateState.current, resolveLink }) }) }) }) : /* @__PURE__ */ jsx(ShimmerText, { active: isStreaming, children: /* @__PURE__ */ jsx(Text, { variant: "body", as: "span", italic: true, children: t("thinking.placeholder") }) }),
          showSpinner && /* @__PURE__ */ jsx(
            "div",
            {
              ref: spinnerRef,
              className: "buyscout-timeline-thinking-spinner",
              "data-state": spinnerClosing ? "closed" : "open",
              "aria-hidden": true,
              children: /* @__PURE__ */ jsx(Spinner, { size: "sm" })
            }
          )
        ]
      }
    )
  );
}
export {
  ThinkingIndicator
};
//# sourceMappingURL=ThinkingIndicator.mjs.map